var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8032 18V4L6.52128 8.66667H3V13.3333H6.52128L11.8032 18ZM10.2454 7.45668V14.5424L7.11107 11.7735L4.55859 11.7729V10.2262L7.11107 10.2265L10.2454 7.45668Z",
    fill: "#338FCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L20 14M14 14L20 8",
    stroke: "#338FCE",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.df408b8aaa2d8c9f6b089e4692f31610.svg";
export { ForwardRef as ReactComponent };